import { INITIAL_INSIGHTS_STATE } from './insights/survey-creation-insights-state.constants';
import { INITIAL_LOCATION_UPLOAD_STATE } from '@ps/survey-utils';

import {
  QuestionCategoriesState,
  SurveyCreationAudienceState,
  SurveyCreationReferenceState,
  SurveyCreationState,
} from './survey-creation-state.model';

export const INITIAL_QUESTION_CATEGORIES_STATE: QuestionCategoriesState = {
  data: [],
  cachedAt: null,
  loading: false,
};

export const INITIAL_SURVEY_CREATION_AUDIENCE_STATE: SurveyCreationAudienceState =
  {
    surveyId: null,
    survey: null,
    error: null,
    metadata: { value: null, valid: false, errors: [] },
    qualifications: { value: [], valid: true, errors: [] },
    quotas: { value: [], valid: true, errors: [] },
    locationFileUpload: { ...INITIAL_LOCATION_UPLOAD_STATE },
  };

export const INITIAL_SURVEY_CREATION_REFERENCE_STATE: SurveyCreationReferenceState =
  {
    qualificationsRecord: {},
    questionCategories: { ...INITIAL_QUESTION_CATEGORIES_STATE },
    questionsRecord: {},
    questionsLoadingKey: null,
    locationConditionsRecord: {},
    locationConditionsLoadingKey: null,
  };

export const INITIAL_SURVEY_CREATION_STATE: SurveyCreationState = {
  audience: { ...INITIAL_SURVEY_CREATION_AUDIENCE_STATE },
  insights: { ...INITIAL_INSIGHTS_STATE },
  reference: { ...INITIAL_SURVEY_CREATION_REFERENCE_STATE },
};
